import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach bearer token from localStorage as fallback (cookie-first)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("eo_token");
  if (t && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function docPreviewUrl(docId, { inline = false } = {}) {
  const t = localStorage.getItem("eo_token") || "";
  const params = new URLSearchParams({ token: t });
  if (inline) params.set("inline", "1");
  return `${API_BASE}/documents/${docId}/download?${params.toString()}`;
}

export default api;
